module.exports = __webpack_public_path__ + "static/media/ta-rpo-04.6163010f.png";